import { SendToMailState, SendToMailRequest } from 'Application/models';
import { PostPolicyToMail, PostToMail } from 'Application/service';
import { create } from 'zustand';

export const useSendToMailStore = create<SendToMailState>((set) => ({
    isLoading: false,
    isError: false,
    error: null,
    sendToMailData: null,

    sendToMail: async (sendToMailData: SendToMailRequest, quoteId: string) => {
        set({ isLoading: true });

        try {
            await PostToMail(sendToMailData, quoteId);

            set({ isError: false, error: null });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    },

    sendPolicyToMail: async (policyNumber: string) => {
        set({ isLoading: true });

        try {
            await PostPolicyToMail(policyNumber);

            set({ isError: false, error: null });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    }
}));
